var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRank04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32.91,60.18v-8.18H7.45v-13.63L29.42,3.82h21.1v33.14h6.03v15.04h-6.03v8.18h-17.6Zm.31-23.23v-10.14l-6.39,10.14h6.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.45,50v-11.05L30.52,5.82h10.02v14.73h-5.73l-11.35,18v.41h31.09v11.05H9.45Zm25.47,8.18v-11.56l.31-4.81V5.82h13.3v52.36h-13.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank04);
export default __webpack_public_path__ + "static/media/rank_04.ebece3fffcb605eca7258aa5ab418326.svg";
export { ForwardRef as ReactComponent };